import { DuplicateId, DuplicateIdProps } from "../DuplicateId";
import { AutogenLayoutStatusCode } from "./autogen/AutogenLayoutStatusCode";

const viewStatusCodeURL = "lme/dispatch/asset/StatusCode?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "equipstatuscode",
    screenName: "Status Code",
    altFieldNameForDupCheck: "code",
    navigateToUrl: viewStatusCodeURL
};

export class StatusCode extends AutogenLayoutStatusCode {

    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxCode, DUPLICATE_VALIDATION_PROPS);
    }

}
